import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { VscRefresh } from "react-icons/vsc";
import * as Styles from "../../styles";
import { Lead } from "../../../../../../interfaces";
import { isCorretor } from "../../constants";

interface Props {
  item: Lead;
  codigoCargo: string | null;
  onEtapaClick: (item: Lead) => void;
}

export const EtapaCell: React.FC<Props> = ({
  item,
  codigoCargo,
  onEtapaClick,
}) => (
  <Tooltip
    followCursor
    title={item.etapaFunil || "--"}
    placement="top-start"
    arrow
  >
    <Styles.Td style={{ paddingRight: 8 }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Styles.ButtonEtapa
          type="button"
          disabled={!isCorretor(codigoCargo)}
          onClick={() => onEtapaClick(item)}
        >
          <p
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              fontSize: 14,
              fontFamily: "Inter",
              color: "#424248",
            }}
          >
            {item.etapaFunil || "--"}
          </p>
          <VscRefresh color="#2D5BFF" size={18} style={{ minWidth: 18 }} />
        </Styles.ButtonEtapa>
      </div>
    </Styles.Td>
  </Tooltip>
);
